module.exports = __webpack_public_path__ + "assets/img/jtfx51.408feef9.png";